<template>
    <el-card style="width:100%;
               height:800px;
               margin-left: auto;
               margin-right: auto;
               margin-top: 15px;
               position: relative;
               color: rgb(250,170,0);
               font-size: 14px;">
    <div style=" height: 800px; width: 100%;">
    <!-- <div style="position: absolute; top: 20px; left: 50px; z-index: 100;">
        <el-radio v-model="network_type" label="inter" border>Interlink</el-radio>
        <el-radio v-model="network_type" label="full" border>Full-link</el-radio>
    </div> -->
    
    <div id="echart-network" style="height: 100%; width: 100%;"></div>
    <el-card class="box-card" 
            style="height:auto;
            width:255px;
            background-color: rgba(255,255,255,0.9);
            color: rgb(250,170,0);
            font-size: 17px;
            position: absolute;
            bottom:600px;
            left:45px">
            <input type="text" id="inputSearch" placeholder="Enter single name here" v-model="searchValue" style="outline:none;height:35px;width:65%;">
            <el-button size="small" @click="search('enter')" type="warning" style="font-size: 11px;text-align:center;margin-left:1%;width:27%;height:40px">Search</el-button>
    </br></br><div style="font-size: 17px; font-weight: bold;" >Or click the certain node to show the sub-network.</div>
    </el-card>  
    <div style="position: absolute; top: 220px; left:50px; width:250px;color:black;text-align: left;">
       <!-- *Interlink: Only show edges between different-omics nodes.</br> -->
        *To make the plot clearer, we only showed nodes and edges with higher reliability.</br>
        *The node size represents its degree.</br>
        *Swipe the mouse wheel to zoom
    </div>
</div>
</el-card>
    
</template>

<script>

var option;
export default({
    props:{
        nodes:Array,
        full_edges:Array,
        // inter_edges:Array,
    },
    data(){
        return{
            myChart:null,
            searchValue:"BDNF",
            edges:this.full_edges,
            network_type:"full",
            categories:[
                {name: 'SNP'},
                {name: 'Gene'},
                {name: 'RNA'},
                {name: 'Methylation'},
            ],
        }
    },
    // watch:{
    //     network_type(){
    //         if (this.network_type == 'inter') {
    //             this.edges=this.inter_edges; // 模式1的边
    //             this.nodes.forEach(node => {
    //                 node.symbolSize = node.symbolSize_inter; 
    //                 node.label = {show: node.symbolSize > 15};
    //             });     
    //         } else{
    //             this.edges=this.full_edges;
    //             this.nodes.forEach(node => {
    //                 node.symbolSize = node.symbolSize_full; 
    //                 node.label = {show: node.symbolSize > 25}
    //             });
    //         }
    //         this.myChart.setOption({
    //             series: [{
    //                 links: this.edges,
    //                 data:this.nodes,
    //                 zoom:0.3,
    //             }]
    //         });
    //     },
    // },
    mounted() {
        this.initChart(); 
    },
    beforeDestroy() {
        this.myChart.clear()
        this.myChart.dispose()
        this.myChart = null
    },

    methods: {
        // 根据节点找子图
        search(choice){
            if(choice=="enter"){
                console.log(this.searchValue)
                var node_ids=this.nodes.filter(node => node.name === this.searchValue).map(node => node.id); // 从这些节点中提取id
                if (node_ids.length==0) {
                    this.$message.error("Node not found. Please try other names.")
                    return;
                }
                var related_edges = this.edges.filter(edge => node_ids.includes(edge.source) || node_ids.includes(edge.target));
            }else{
                var related_edges = this.edges.filter(edge =>this.searchValue==edge.source || this.searchValue==edge.target);
                this.searchValue=this.nodes.find(node => node.id === this.searchValue)?.name
            }
            var degrees = {};
            related_edges.forEach(edge => {
                degrees[edge.source] = (degrees[edge.source] || 0) + 1;
                degrees[edge.target] = (degrees[edge.target] || 0) + 1;
            });
            var related_nodes = this.nodes.filter(node => degrees[node.id])
                              .map(node => JSON.parse(JSON.stringify(node)));;
            related_nodes.forEach(function (node) {
                node.label = {
                    show: true
                };
            });
            this.myChart.dispatchAction({
                type: 'restore' // 使用 restore 类型来重置图表状态
            });
            this.myChart.setOption({
                series: [{
                    links:related_edges,
                    data:related_nodes,
                    zoom:3,
                }]
            });
            
        },
        initChart() {
            this.nodes.forEach(node => {
                if(this.network_type=="inter")node.symbolSize = node.symbolSize_inter; 
                else node.symbolSize = node.symbolSize_full; 
                node.label = {
                    show: node.symbolSize > 15
                };
            });
            // 如果已存在视图实例，则先销毁后创建
            if (this.myChart != null && this.myChart != "" && this.myChart != undefined) {
                this.myChart.dispose();
            }
            // 基于准备好的dom，初始化echarts实例
            this.myChart = this.echarts.init(document.getElementById("echart-network"));
            option = {
                tooltip: {
                    formatter: function (param) {
                        var value = param.data;
                        // if(value['source']){
                        //     return value['source'] + '--' +value['target']
                        // }
                        if(value['category']=='SNP'){
                            return '<div style="border-bottom: 1px solid rgba(255,255,255,.3); font-size: 18px;padding-bottom: 7px;margin-bottom: 7px">'
                                    + value['name']
                                    + '</div>'
                                    + 'Gene name: ' + value['gene'] + '<br>'
                                    + 'Allele: ' + value['allele'] + '<br>'  
                                    + 'Position: ' + value['position'] + '<br>' 
                        }else if(value['category']=='Gene'){
                            return '<div style="border-bottom: 1px solid rgba(255,255,255,.3); font-size: 18px;padding-bottom: 7px;margin-bottom: 7px">'
                                    + value['name']
                                    + '</div>'
                                    + 'Gene ID: ' + value['gene_id'] + '<br>'
                                    + 'Location: ' + value['location'] + '<br>' 
                                    + 'Type: ' + value['type'] + '<br>'  
                        }else if(value['category']=='RNA'){
                            return '<div style="border-bottom: 1px solid rgba(255,255,255,.3); font-size: 18px;padding-bottom: 7px;margin-bottom: 7px">'
                                    + value['name']
                                    + '</div>'
                                    + 'Gene ID: ' + value['gene_id'] + '<br>'
                                    + 'Original name: ' + value['rna_name'] + '<br>'
                                    + 'Location: ' + value['location'] + '<br>' 
                                    + 'Type: ' + value['type'] + '<br>'  
                        }else if(value['category']=='Methylation'){
                            return '<div style="border-bottom: 1px solid rgba(255,255,255,.3); font-size: 18px;padding-bottom: 7px;margin-bottom: 7px">'
                                    + value['name']
                                    + '</div>'
                                    + 'Gene name: ' + value['gene_name'] + '<br>'
                                    + 'Gene ID: ' + value['gene_id'] + '<br>'
                                    + 'Probe ID: ' + value['probe'] + '<br>'
                                    + 'Location: ' + value['location'] + '<br>' 
                        }
                    }
                },
                title: {
                    text: 'Knowledge graph',
                    left: 'center'
                },
                toolbox: {
                    right: 100,
                    top:50,
                    feature: {
                        restore: {
                            title:"Restore"
                        },
                        saveAsImage: {
                            title:"Download as image"
                        }
                    }
                },
                legend: [
                    {
                        // orient: 'vertical',
                        right: 190,
                        top:50,
                        data: this.categories.map(function (a) {
                            return a.name;
                        })
                    }
                ],
                series: [
                {
                    large:true,
                    type: 'graph',
                    layout: 'force',
                    draggable: true,
                    categories:this.categories,
                    data:  this.nodes,
                    links: this.edges,
                    roam: true,
                    zoom:0.3,
                    animation: false,
                    label: {
                        position: 'right',
                    },
                    emphasis: {
                        focus: 'adjacency',
                        lineStyle: {
                            width: 10
                        }
                    },
                    force: {
                        // gravity: 0.2,
                        initLayout:'circular',
                        repulsion: 200, // 增大这个值可以使得节点之间的距离变大
                        edgeLength: 100,
                        // friction: 0.05,
                        
                    },
                    itemStyle: {
                        borderWidth: 0.5,
                        borderColor: 'white'
                    },
                },
                ]
            };
            this.myChart.setOption(option);
            this.myChart.on('click', (params) => {
                if (params.dataType === 'node') {
                    this.searchValue=params.data.id
                    this.search("click")
                }
            });
        },
        
    }
})
</script>

<style>
.el-radio.is-bordered.is-checked {
    border-color: rgb(230,162,60) !important;
}
.el-radio__input.is-checked+.el-radio__label {
    color: rgb(230,162,60) !important;
}
.el-radio__input.is-checked .el-radio__inner {
    border-color: rgb(230,162,60) !important;
    background: rgb(230,162,60) !important;
}
</style>
